module.exports = __webpack_public_path__ + "img/edit_red.e5f507cc.svg";